import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { baseOptionTypeArrayToStringArray } from 'components/BaseForm/utils';
import { TableSort } from 'components/WrappedComponents/Table/types';
import { useExportDashboard } from 'hooks/dossiers/useExportDashboard';
import { useUserStore } from 'hooks/UserStoreContext';

import { DashboardFOFilter } from '../../types';

interface DownloadButtonProps<SortType extends string | undefined> {
  filters: Partial<DashboardFOFilter>;
  sort: TableSort<SortType>;
}

function DownloadButton<SortType extends string | undefined>({
  filters,
  sort,
}: DownloadButtonProps<SortType>): React.ReactElement {
  const { exportDashboard, inProgress } = useExportDashboard();
  const user = useUserStore();

  return (
    <AntdButton
      icon={<DownloadOutlined />}
      type={'default'}
      shape={'round'}
      onClick={() => {
        exportDashboard(sort, {
          dateRangeMiseEnFourriere: filters.dateRangeMiseEnFourriere,
          communeEnlevementList: baseOptionTypeArrayToStringArray(
            filters.commune,
          ),
          idNatureBrancheList: filters.natureMiseEnFourriere,
          statutDossierEnumList: filters.statut,
          classementList: filters.classement,
          dateRangeBonEnlevement: filters.dateRangeBonEnlevement,
          dateRangeSortieDefinitive: filters.dateRangeSortieDefinitive,
          includeDossiersSortis: filters.includeDossiersSortis,
          numeroRecherche: filters.search,
          idFourriereList: baseOptionTypeArrayToStringArray(filters.fourriere),
          idUniteFO: user.idCorrelationUniteFO ?? undefined,
          actionsRequises: filters.actionsRequises,
          idMotifSortieList: filters.motifDeSortie,
          includeDossiersAnonymises: filters.includeDossiersAnonymises,
          listUniteFo: baseOptionTypeArrayToStringArray(filters.idUniteFOList),
          dateRangeOrdreDestruction: filters.dateRangeOrdreDestruction,
          marque: filters.idMarque,
          modele: filters.idModele,
        });
      }}
      loading={inProgress}
    />
  );
}

export default DownloadButton;
